module.exports = __webpack_public_path__ + "img/lg_ring_y_e_1_0.d9efcd64.png";